import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MesaDeAyudaService {
  public url: string;
  public identity;
  public token;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public http: HttpClient
  ) {
    this.url = GLOBAL.url;
  }

  getToken() {
    let token = localStorage.getItem('token');
    if (token !== 'undefined') {
        this.token = token;
    } else {
        this.token = null;
    }
    return this.token;
  }


  saveTicket(parametros): Observable<any> {
    let headers = new HttpHeaders().set('Authorization', this.getToken());
    return this.http.post(this.url + 'create/new/ticket', parametros, { headers });
  }

  getTiposTicket(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.url + 'get/tipos/ticket', { headers });
   }

   getMisUpaegsCombo(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this.http.get(this.url + 'get/misunidades/combo', { headers });
  }

  getMisTickets(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this.http.get(this.url + 'get/tickets', { headers });
  }


  getDetalleTicket(id): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this.http.get(this.url + 'get/ticket/' + id, { headers });
  }

  sendRespuesta(parametros): Observable<any> {
    let headers = new HttpHeaders().set('Authorization', this.getToken());
    return this.http.post(this.url + 'save/ticket/respuesta', parametros, { headers });
  }

  getDocumentosForTipoTicket(idTipoTicket): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(this.url + 'get/ticket/requisitos/tipo/' + idTipoTicket, { headers });
   }



}
